(function () {
  'use strict';

  const { iman } = window.Universe;

  class Form {
    constructor(section) {
      this.init(section);
    }

    setup() {
      this.DOM.form.addEventListener('submit', this.onSubmit);
    }

    resize() {}

    destroy() {
      if (this.DOM) {
        this.DOM = undefined;
      }
    }

    init(section) {
      if (section) {
        this.DOM = {};
        this.DOM.section = section;
        this.DOM.form = this.DOM.section.querySelector('.js-contact-form');

        this.onSubmit = (event) => {
          event.preventDefault();
          const action = this.DOM.form.getAttribute('action');
          console.log(action);
        };

        this.setup();
      }
    }
  }

  class ContactForms {
    constructor() {
      this.init();
    }

    setup() {
      for (let i = 0; i < this.DOM.sections.length; i++) {
        this.instances.push(new Form(this.DOM.sections[i]));
      }
    }

    resize() {
      for (let i = 0; i < this.instances.length; i++) {
        this.instances[i].resize();
      }
    }

    reinit() {
      this.destroy();
      this.init();
    }

    destroy() {
      if (this.DOM) {
        for (let i = 0; i < this.instances.length; i++) {
          this.instances[i].destroy();
        }
        this.instances = [];
        this.DOM = undefined;
      }
    }

    init(container = document) {
      const sections = container.querySelectorAll('.js-contact-form-section');

      if (sections.length) {
        this.DOM = {};
        this.DOM.sections = sections;
        this.instances = [];
        this.setup();
      }
    }
  }

  function init() {
    if (!iman.get('contactForms')) {
      iman.add('contactForms', new ContactForms());
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.Universe.ContactForms = ContactForms;
})();
